/** API error code for a selected user who lacks the required product. */
export const USER_PRODUCT_MISSING_ERROR_CODE = 'user-product-missing'
